import { EnvConfiguration } from './models';
import URI from 'urijs';

class EnvSettingsSingleton {
  private static env: EnvConfiguration;

  private static initialize() {
    const mode = process.env.NODE_ENV;
    switch (mode) {
      case 'production':
        this.env = require('./.env.production').default;
        break;
      case 'development':
        this.env = require('./.env.development').default;
        break;
      case 'local':
        this.env = require('./.env.local').default;
        break;
    }
  }

  public static get instance(): EnvConfiguration {
    if (this.env == null) {
      this.initialize();
    }
    return this.env;
  }
}

const AdminApiOptions = {
  endpointUrl(relativePath: string): string {
    return new URI(EnvSettingsSingleton.instance.AdminApiBaseUrl)
      .segment(relativePath)
      .toString();
  },
};

const CoreApiOptions = {
  endpointUrl(relativePath: string): string {
    return new URI(EnvSettingsSingleton.instance.CoreApiBaseUrl)
      .segment(relativePath)
      .toString();
  },
};

const LeagueApiOptions = {
  endpointUrl(relativePath: string): string {
    return new URI(EnvSettingsSingleton.instance.LeagueApiBaseUrl)
      .segment(relativePath)
      .toString();
  },
};

export const Env = {
  ...EnvSettingsSingleton.instance,
  AdminApiOptions,
  CoreApiOptions,
  LeagueApiOptions,
};
